import {
  OPPORTUNITY_MASS_ASSIGN,
  CITY_LIST,
  OPPORTUNITY_SEARCH_LIST,
  HOUSING_TOP_CITY_LIST,
  PT_CITY_LIST,
  RESHARE_OWNER_OPP_LINK,
  PACKAGE_CITY_LIST,
  PT_CITY_LIST_FAIL,
  PT_ACTIVE_INACTIVE_CITY_LIST,
  PT_ACTIVE_INACTIVE_CITY_LIST_FAIL,
  PT_CITY_LIST_IN_PROGRESS,
} from "../actions/opportunitySearch.actions";

const defaultState = {};
const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case OPPORTUNITY_MASS_ASSIGN:
      return {
        ...state,
        opportunityMassAssignStatus: action.payload,
      };
    case CITY_LIST:
      return {
        ...state,
        citiesMap: action.citiesMap,
        allCities: action.allCities,
        cities: action.cities,
      };
    case OPPORTUNITY_SEARCH_LIST:
      return {
        ...state,
        opportunitySearchList: action.opportunitySearchList,
      };
    case HOUSING_TOP_CITY_LIST:
      return {
        ...state,
        topCities: action.payload,
      };
    case PT_CITY_LIST:
      return {
        ...state,
        ptCitiesFail: false,
        ptCitiesIdtoLabel: action.ptCitiesIdtoLabel,
        citiesData: action.citiesData,
        ptCities: action.ptCities,
      };
    case PT_CITY_LIST_FAIL:
      return {
        ...state,
        ptCitiesFail: true,
        snackbar: {
          state: true,
          type: "error",
          duration: action.duration || null,
          message: action.errMsg || "Something went wrong!",
        },
      };
    case PT_ACTIVE_INACTIVE_CITY_LIST:
      return {
        ...state,
        ptActiveInactiveCitiesFail: false,
        ptActiveInactiveCitiesIdtoLabel: action.ptActiveInactiveCitiesIdtoLabel,
        citiesActiveInactiveData: action.citiesActiveInactiveData,
        ptActiveInactiveCities: action.ptActiveInactiveCities,
      };
    case PT_ACTIVE_INACTIVE_CITY_LIST_FAIL:
      return {
        ...state,
        ptActiveInactiveCitiesFail: true,
        snackbar: {
          state: true,
          type: "error",
          duration: action.duration || null,
          message: action.errMsg || "Something went wrong!",
        },
      };
    case PT_CITY_LIST_IN_PROGRESS:
      return {
        ...state,
        ptCitiesInProgress: action.payload,
      };
    case RESHARE_OWNER_OPP_LINK:
      return {
        ...state,
        snackbar: {
          state: true,
          type: "success",
          duration: null,
          message: action.msg || "Link Re-shared Successfully",
        },
      };
    case PACKAGE_CITY_LIST:
      return {
        ...state,
        packageCities: action.packageCities,
      };
  }
};

export default reducer;
